//import Example from './example';

jQuery(($) => {
    /**
     * Video modal
     */
    const modals = document.querySelectorAll(".video_modal");

    modals.forEach((modal) => {
        const placeholder = modal.querySelector(".video_modal__placeholder");

        // When modal is shown
        modal.addEventListener("shown.bs.modal", (e) => {
            const button = e.relatedTarget;
            const src = button.dataset.src;
            if (src) {
                // Add autoplay to the URL
                const autoplaySrc = src.includes("?")
                    ? `${src}&autoplay=1`
                    : `${src}?autoplay=1`;

                // Create iframe
                const iframe = document.createElement("iframe");
                iframe.src = autoplaySrc;
                iframe.width = "100%";
                iframe.height = "100%";
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute(
                    "allow",
                    "autoplay; encrypted-media; picture-in-picture"
                );
                iframe.setAttribute("allowfullscreen", "true");

                // Insert iframe into placeholder
                placeholder.innerHTML = "";
                placeholder.appendChild(iframe);
            }
        });

        // When modal is hidden
        modal.addEventListener("hidden.bs.modal", () => {
            // Remove iframe to stop video and reset
            placeholder.innerHTML = "";
        });
    });
});
